import app from '../app';
import { EPreferredCommunicationType } from '../../../../shared/redux/reducers';
import { REGIONS_FORMS_COMMUNICATION } from '../../../../shared/constants';
import { isNewOffer } from './ad-state.service';
import { selectHomeownerNewAddFormEnabled } from '../../../../shared/selectors/abExperiments/selectHomeownerNewAddFormEnabled';
import { selectIsByHomeowner, selectLocationsFromAddress } from '../../../../shared/selectors/offer';

app.service('rentHelperService', [
  '$cookies',
  'analyticsService',
  'addFormService',
  'config',
  'store',
  '$injector',
  function ($cookies, analyticsService, addFormService, config, store, $injector) {
    const regions = config.get('DealRent.DealRegionIds');

    this.trapShown = false;

    const isHomeownerNewAddFormEnabled = () => {
      const state = store.getState();

      const result =
        selectHomeownerNewAddFormEnabled(state) &&
        addFormService?.ad?.bargainTerms.leaseTermType === 'longTerm' &&
        selectIsByHomeowner(state) &&
        regions.includes(selectLocationsFromAddress(state)?.[0]);

      return result;
    };

    this.checkIsHomeownerNewAddFormEnabled = () => {
      if (isHomeownerNewAddFormEnabled()) {
        const activeDraftService = $injector.get('activeDraftService');
        activeDraftService.setDraftMode(activeDraftService.modeEnums.REMOTE);
        activeDraftService.enableActiveDraft().then(() => {
          window.location.replace('/publish-homeowner-offer');
        });
      }
    };

    this.showRentHelperTrap = () => {
      const doCommunicationTypeTrap = this.isNeedToShowCommunicationTypeTrap();

      if (doCommunicationTypeTrap) {
        if (!this.trapShown) {
          analyticsService.trackCommunicationHelperShow();
          this.trapShown = true;
        }

        return doCommunicationTypeTrap;
      }

      return false;
    };

    this.isFormsAvailable = () => {
      const result =
        addFormService.ad &&
        addFormService.ad.bargainTerms &&
        (addFormService.ad.bargainTerms.leaseTermType === 'longTerm' ||
          addFormService.ad.bargainTerms.leaseTermType === 'fewMonths') &&
        addFormService.ad.isByHomeowner &&
        addFormService.ad.category === 'flatRent';

      return result;
    };

    this.isCommunicationTypeFormsSelected = () => {
      return (
        addFormService.ad.communication &&
        addFormService.ad.communication.preferredCommunicationType === EPreferredCommunicationType.Forms
      );
    };

    /**
     * Для пользаков в эксперименте Анкеты для всех собов и в эксперименте Ловушка 1/2 для анкет
     * выводим ловушку для анкет вместо ловушки 1/3
     * @returns {boolean}
     */
    this.isNeedToShowCommunicationTypeTrap = () => {
      const state = store.getState();

      const locations = selectLocationsFromAddress(state);

      const result =
        this.isFormsAvailable() &&
        isNewOffer &&
        !addFormService.ad.communication?.preferredCommunicationType &&
        REGIONS_FORMS_COMMUNICATION.includes(locations?.[0]);

      return result;
    };

    this.changeCommunicationTypeToForms = preferredCommunicationType => {
      addFormService.ad.communication = {
        preferredCommunicationType,
      };
    };
  },
]);
